import React from "react";
import { Box, Typography, Divider } from "@mui/material";
import backgroundImage from "../../assets/Cairo3.jpg";  // ✅ Check the import path
import { useTranslation  } from 'react-i18next';
const KnowUs = () => {
  const { t, i18n } = useTranslation();
  
  const isRTL = i18n.language === 'ar';

  return (
    
    <Box
      sx={{
        position: "relative",
        height: "100vh",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
        backgroundColor: "rgba(0,0,0,0.5)",
        
      }}
    >
      {/* Fixed Background */}
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundImage: `url(${backgroundImage})`, // ✅ Fix background image
          backgroundSize: "cover",
          backgroundPosition: "center",
          boxShadow: "0 0 10px rgba(0,0,0,0.5)",
          backgroundRepeat: "no-repeat",
          zIndex: -1, // ✅ Sends it behind the text
        }}
      />

      {/* Text */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          position: "relative",
          textAlign: "left",
          width: { md: "50%", xs: "100%" },
          mb: 8,
          marginInline: { md: 19, xs: 1 },
          flexDirection: "column",
        }}
      >
      <Typography
        variant="h3"
        sx={{
          color: "white",
          textShadow: "2px 2px 10px rgba(0,0,0,0.7)",
          fontWeight: "600",
          fontSize: { xs: '1.5rem', md: '2rem' },
          lineHeight: { xs: '1.5rem', md: '2rem' },
          fontFamily: isRTL ? 'Noto Sans Arabic' : 'Noto Sans',
          textAlign: { xs: 'center', md: isRTL ? 'right' : 'left' },
          direction: isRTL ? 'rtl' : 'ltr',
        }}
      >
        {t('Titles.know_us')}
      </Typography>
      <Divider sx={{ backgroundColor: 'primary.main', width: '10vh', height: '3px' ,margin: { xs: '20px auto', md: isRTL ? '20px 0 20px auto' : '20px auto 20px 0'} }} />
      <Typography
        variant="h3"
        sx={{
          color: "white",
          textShadow: "2px 2px 10px rgba(0,0,0,0.7)",
          fontSize: { xs: '1rem', md: '1.3rem' },
          lineHeight: { xs: '1rem', md: '1.5rem', lg: '2rem' },
          fontFamily: isRTL ? 'Noto Sans Arabic' : 'Noto Sans',
          textAlign: isRTL ? 'right' : 'left',
          direction: isRTL ? 'rtl' : 'ltr',
        }}
      >
        {t('Descriptions.know_us')}
      </Typography>
      
      <Typography
        variant="h3"
        sx={{
          color: "white",
          textShadow: "2px 2px 10px rgba(0,0,0,0.7)",
          fontSize: { xs: '1rem', md: '1.3rem' },
          lineHeight: { xs: '1rem', md: '1.5rem', lg: '2rem' },
          fontFamily: isRTL ? 'Noto Sans Arabic' : 'Noto Sans',
          textAlign: { xs: 'center', md: isRTL ? 'right' : 'left' },
          // direction: isRTL ? 'rtl' : 'ltr',
        }}
      >
        {t('Descriptions.know_us_2')}
      </Typography>
      </Box>
    </Box>
  );
};

export default KnowUs;
